export default __webpack_public_path__ + "img/bmfPzBxf.eb3960fd.svg";